import BaseService from "./BaseService";
import { unwrapResponse } from "./unwrapResponse";
import axios from "axios";
export default class AdminFormService extends BaseService {
    static async list(params = {}) {
        const res = await this.get(`/forms`, params, "ADMIN");
        return unwrapResponse(res);
    }
    static async getById(id) {
        const res = await this.get(`/forms/${id}`, {}, "ADMIN");
        return unwrapResponse(res);
    }
    static async create(payload) {
        const res = await this.post(`/forms`, payload, "ADMIN");
        return unwrapResponse(res);
    }
    static async update(id, payload) {
        const res = await this.put(`/forms/${id}`, payload, "ADMIN");
        return unwrapResponse(res);
    }
    static async activate(id) {
        const res = await this.post(`/forms/${id}/activate`, {}, "ADMIN");
        return unwrapResponse(res);
    }
    static async pause(id) {
        const res = await this.post(`/forms/${id}/pause`, {}, "ADMIN");
        return unwrapResponse(res);
    }
    static async remove(id) {
        const res = await axios.delete(BaseService.getUrl(`/forms/${id}`, "ADMIN"));
        return unwrapResponse(res);
    }
    static async summary(id) {
        const res = await this.get(`/forms/${id}/summary`, {}, "ADMIN");
        return unwrapResponse(res);
    }
    static async responses(id, params = {}) {
        const res = await this.get(`/forms/${id}/responses`, params, "ADMIN");
        return unwrapResponse(res);
    }
}
